import { useEffect } from 'react';

/**
 * Forwards a given MapKit JS event to a mapkit-react event.
 * @param element The current map | marker | annotation instance
 * @param name The name of the MapKit JS event.
 * @param handler The event handler of the mapkit-react Map component
 * @param eventMap A function that transforms the parameter of the
 *                 MapKit JS event handler to a parameter for the
 *                 mapkit-react event handler.
 */
export default function forwardMapkitEvent<E>(
  element: mapkit.Map | mapkit.Annotation | mapkit.MarkerAnnotation | null,
  name: string,
  handler: ((mapkitReactEvent: E) => void) | undefined,
  eventMap: (mapkitEvent: any) => E
) {
  useEffect(() => {
    if (!element || !handler) return undefined;

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const mapkitHandler = (e) => {
      handler(eventMap(e));
    };

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.addEventListener(name, mapkitHandler);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return () => element.removeEventListener(name, mapkitHandler);
  }, [element, handler]);
}
